<template>
  <nav class="navbar min-w-1400">
    <div class="titBox max-w-1400">
      <div class="logoBox">
        <img
          :src="require('@/page/maxassetcompany/components/img/header_logo.png')"
          alt="logo"
          class="logoImg"
          @click="gotoTop"
        />
        <div class="logoTitle">Maxam สินเชื่อด่วน</div>
      </div>
      <div class="titleBox">
        <span class="title">MAX ASSET MANAGEMENT COMPANY LIMITED</span>
      </div>
    </div>
    <div
      class="secondBox max-w-1400"
      :class="{
        'secondBox-bottom':
          $route.path === '/question' || $route.path === '/protocol',
      }"
    >
      <ul class="nav-links">
        <li  class="Li1 Li about">
          <!-- <router-link to="/" class="nav-link1">
            <span class="routeText1">หน้าแรก</span>
          </router-link> -->
          <!-- <a href="#about">เกี่ยวกับเรา</a> -->
          <a
            class="routeText4"
            href="javascript:void(0)"
            @click="goAnchor('about' )"
          >
            เกี่ยวกับเรา
          </a>
        </li>
        <li  class="Li2 Li mission">
          <a
            class="routeText4"
            href="javascript:void(0)"
            @click="goAnchor('mission')"
            >ภารกิจและวิสัยทัศน์</a
          >
        </li>
        <li class="Li3 Li detail">
          <a
            class="routeText4"
            href="javascript:void(0)"
            @click="goAnchor('detail')"
            >รายละเอียดการกู้ยืม</a
          >
        </li>
        <li  class="Li3 Li comment">
          <a
            class="routeText4"
            href="javascript:void(0)"
            @click="goAnchor('comment')"
            >ความคิดเห็นของผู้ใช้</a
          >
        </li>
        <li class="Li3 Li contact">
          <a
            class="routeText4"
            href="javascript:void(0)"
            @click="goAnchor('contact')"
            >ติดต่อเรา</a
          >
        </li>
        <li
          :class="{ 'active-link': $route.path === '/privacypolicy' }"
          class="Li4"
          @click="behave()"
        >
          <router-link to="/privacypolicy" class="nav-link4">
            <span class="routeText4">ข้อตกลงความเป็นส่วนตัว</span>
          </router-link>
          <!-- <a href="https://dit.qvcreditlaverapp.com/Q6V0rC2t/cn7S3ysxy.html?q7vtc6T=qvector_ios" class="nav-link4" target="_blank">
            <span class="routeText4">ข้อตกลงความเป็นส่วนตัว</span>
          </a> -->
        </li>
      </ul>
    </div>
    <!-- <div style="height: 130px"></div> -->
  </nav>
</template>

<script>
export default {
  data() {
    return {
      link1Color: "white",
      // activeHashed:'about'
    };
  },
  // mounted() {
  //   setInterval(() => {
  //     this.activeHashed = this.$activeHash
  //     console.log('3333',this.$activeHash,this.activeHashed);
  //   }, 5000);
  // },

  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    isActive(route) {
      return this.$route.path === route;
    },
    behave() {
      document.querySelectorAll('.Li').forEach((item) => {
          item.classList.remove("active-link");
        });
    },
    goAnchor(id) {
      const currentPath = this.$route.path;
      if (currentPath !== "/") {
        this.$router
          .push("/")
          .then(() => {
            // 确保页面跳转完成后执行下面的操作
            this.goAnchor(id);
          })
          .catch((err) => {
            // 处理跳转错误
            console.error("跳转错误", err);
          });
      }

      var anchor = document.getElementById(id);

      if (anchor) {
        anchor.scrollIntoView({
          behavior: "smooth", // 平滑滚动
          block: "start", // 滚动到元素顶部
        });
        anchor.scrollTo({ top: 0, behavior: "smooth" });
       
        
        document.querySelectorAll('.Li').forEach((item) => {
          item.classList.remove("active-link");
        });
        
        document.querySelector(`.${id}`).classList.add("active-link");
        // console.log(document.querySelectorAll('Li'));
      }
    },
  },
};
</script>
<style scoped>
.navbar {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  background-color: "";
  /* height: 90px; */
  position: sticky;
  top: 0;
  z-index: 1000;
}
.titBox {
  padding: 20px 200px;
  background: #ffffff;
  display: flex;
  width: 100%;
  justify-content: center;
  position: relative;
}

.secondBox {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  /* height: 90px; */
  padding: 0 200px;
  background: #FF6819;
  /* box-shadow: 0px 3px 12.2px 0 rgba(65, 64, 64, 0.1); */
  /* background-image: url("@/page/bienestarricotecnologia/components/img/NavBg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%; */
  box-shadow: 0px 4px 9.4px 0px rgba(0, 0, 0, 0.05);
}

.secondBox-bottom {
  /* box-shadow: 0px 1.5px 0px rgba(54, 53, 56, 1); */
}

.logoBox {
  position: absolute;
  display: flex;
  align-items: center;
  left: 259px;
  top: 0;
  height: 100%;
}

.titleBox {
  font-weight: bold;
  color: black;
  display: flex;
  align-items: center;
}

.logoTitle{
  font-size: 20px;
  font-weight: 600;
  color: #FF6718;
  margin-left: 5px;
}

.logoImg {
  width: 40px;
  height: 40px;
}

.title {
  /* width: 500px; */
  font-size: 18px;
  font-family: DM Sans-Bold;
  font-weight: 600;
  color: #333333;
  /* line-height: 23px; */
  padding-left: 17px;
  /* text-transform: uppercase; */
  height: 24px;
  line-height: 24px;
  /* height: 90px;
  line-height: 90px; */
}

.routeText1,
.routeText2,
.routeText3,
.routeText4,
.routeText5 {
  font-size: 16px;
  font-family: SF Pro-Semibold;
  /* font-weight: 400; */
  color: #ffffff;
  /* opacity: 0.8; */
  /* line-height: 29px; */
  /* text-transform: uppercase; */
}

.nav-link1,
.nav-link2,
.nav-link3,
.nav-link4,
.nav-link5 {
  text-decoration: none;
  margin: 0 auto;
}

.nav-links {
  list-style: none;
  display: flex;
  align-items: center;
  /* 垂直居中对齐 */
  justify-content: space-between;
  /* 水平居中对齐 */
  /* height: 100%; */
  width: 100%;
  height: 60px;
  /* gap: 10px; */
}

.nav-links li {
  /* border: 1px solid red; */
  display: flex;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  align-items: center;
  /* padding-left: 4px;
  padding-right: 4px; */
  /* padding: 6px; */
  height: 100%;
  /* line-height: 90px; */
}

/* .Li1 {
  width: 100px;
}

.Li2 {
  width: 140px;
}

.Li3 {
  width: 120px;
}

.Li4 {
  width: 200px;
} */

.Li5 {
  /* width: 210px; */
  /* 这个如果给margin-right底部可能会出现边距的问题 */
}

.active-link {
  /* border-color: #48B46E; */
  /* background-color: #b383ea; */
  color: #ffffff;
  border-radius: 8px;
}

.active-link .routeText1,
.active-link .routeText2,
.active-link .routeText3,
.active-link .routeText4,
.active-link .routeText5 {
  font-family: Inter-Extra Bold;
  font-weight: bold;
  color: #ffffff;
  /* opacity: 1; */
}

.active-link .routeText1::after,
.active-link .routeText2::after,
.active-link .routeText3::after,
.active-link .routeText4::after,
.active-link .routeText5::after {
  content: "";
  display: block;
  /* 初始时下划线可见 */
  border-bottom: 4px solid #fff;
  border-radius: 20px;
  /* 调整下划线的长度 */
  /* width: 50%;  */
  transition: width 0s ease-in-out; /* 添加 transition 效果 */
  /* margin-top: 10px; */
}

.title {
  /* border: 1px solid red; */
  /* padding-left: 30px; */
  /* width: 600px */
}

.secondBox {
  /* padding: 0 100px 0 50px; */
}
</style>
